<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    :class="['title-page', {
      'title-page--codigos': typePortal === 'codigos',
      'title-page--verano-joven': typePortal === 'verano-joven',
    }]"
  >
    <h1 class="title-page__title">
      {{ props$$.title }}
      <span v-if="store.getters['app/hasDualYear']">
        para el registro <b> {{ productYear }} </b>
      </span>
      <span
        v-if="isModeTest"
        class="title-page__title__test-mode"
      >
        {{ modeTestTexts }}
      </span>
    </h1>
  </div>
  <div
    v-if="activeNotice"
    class="banner-notice"
    v-html="noticeTexts"
  />
</template>

<script setup>
// #region VUE
import {computed, ref} from 'vue';

import {useStore} from 'vuex';
// #endregion

// #region Props, Emits
const props$$ = defineProps({
  title: {
    type: String,
    default: '',
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const activeNotice = Number(STTEDRA_ACTIVE_NOTICE) ? true : false;
const isModeTest = Number(STTEDRA_MODE_TEST) ? true : false;
const store = useStore();
const modeTestTexts = computed(() => store.getters['text/getSectionTexts']('mode-test'));
const noticeTexts = computed(() => store.getters['text/getSectionTexts']('notice'));
const productYear = computed(() => store.state.app.productYear);
const typePortal = ref(STTEDRA_TYPE_PORTAL);
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.title-page{
  position: relative;

  background: rgb(248, 248, 248);
  background: linear-gradient(90deg, rgba(248, 248, 248, 1) 39%, rgba(255, 255, 255, 1) 100%);
  padding: 16px 16px 16px 56px;
  border: none;
  position: relative;
  margin-left: 20px;

  @media print {
    padding: 8px 8px 8px 28px !important;
  }

  &:before{
    background: transparent var(--url-chevron);
    background-repeat: no-repeat;
    content: " ";
    display: inline-block;
    position: absolute;
    top: 6px;
    left: -16px;
    z-index: 10;
    width:40px;
    height:50px;
    background-size: contain;

    @media print {
      top: 8px;
      left: -8px;
      width:20px;
      height:25px;
    }
  }
  &__title{
    border-radius: 0.8rem;
    font-weight: 500;
    font-size: 1.7rem;

    &__test-mode{
      color: var(--red-500);
    }

    @media print {
      font-size: 1.1rem;
    }
  }
}

.banner-notice{
  position: relative;
  padding: 0.75rem 1.25rem;
  margin: 1rem 0rem;
  border: 1px solid #ffe4c3;
  border-radius: 0.375rem;
  background-color: #fff6eb;
  color: #664d03;
  font-size: $pv__fs--large;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  @include media("<=phone") {
    font-size: $pv__fs--medium;
    padding: 0.625rem 1rem;
    margin: 0.75rem 1rem;
  }

  @include media("<=tablet") {
    font-size: $pv__fs--medium;
    margin: 1rem;
  }
}


</style>
